import React from 'react';

import AiSearchBanner from './AiSearchBanner';

const AiSearchBannerMount = () => <AiSearchBanner />;

export default AiSearchBannerMount;
